<script setup lang="ts">
import type { EditorialCrossNavigationProps } from './EditorialCrossNavigation.props'
import emblaCarouselVue from 'embla-carousel-vue'

defineProps<EditorialCrossNavigationProps>()

const [emblaRef] = emblaCarouselVue({
  loop: false,
  containScroll: false,
  align: 'center',
  breakpoints: {
    '(min-width: 768px)': {
      active: false,
    },
  },
})
</script>

<template>
  <div class="editorial-cross-navigation col-span-12 py-10 lg:px-16">
    <UtilsMarkdown
      v-if="subtitle"
      :content="subtitle"
      is-preprocessed
      container="span"
      class="text-book-6 md:text-book-4 text-text-primary mb-2 block px-16 uppercase md:mb-4 lg:px-0 lg:text-right"
    />
    <div
      class="text-text-primary mb-6 flex items-center justify-between px-16 lg:mb-16 lg:px-0"
    >
      <span class="lg:text-h5 hidden lg:block lg:uppercase">
        {{ $ts('editorial.crossNavigation.viewMore') }}
      </span>
      <UtilsMarkdown
        v-if="title"
        :content="title"
        is-preprocessed
        container="span"
        class="text-medium-4 lg:text-medium-3 uppercase"
      />
    </div>
    <div class="grid grid-cols-12 md:px-16 lg:px-0">
      <div class="hidden lg:col-span-2 lg:flex lg:flex-col">
        <UILink
          v-for="category in categories"
          :key="category.label"
          anatomy="link"
          :link-underline="false"
          v-bind="category"
          class="!text-light-5 lg:mb-8 lg:last:mb-0"
        />
      </div>
      <div class="col-span-12 lg:col-span-8">
        <div ref="emblaRef" class="embla overflow-hidden">
          <div
            class="embla__container flex cursor-grab select-none gap-6"
            grab-cursor
          >
            <div
              v-for="card in cards"
              :key="card.link.label"
              class="embla__slide w-3/5 shrink-0 md:w-2/6"
            >
              <UILink
                v-bind="{
                  ...card.link,
                  label: undefined,
                  ariaLabel: card.link.label,
                }"
                anatomy="link"
                :link-underline="false"
              >
                <UIMedia
                  v-bind="card.media!"
                  class="aspect-3/4 mb-4 md:mb-6 lg:mb-8"
                />
                <span
                  class="text-book-6 md:text-book-5 block h-auto p-0 text-center uppercase"
                >
                  {{ card.link.label }}
                </span>
              </UILink>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="border-primitives-grey-100 mt-10 border-y py-4 md:flex md:items-center md:gap-6 lg:hidden"
    >
      <span
        class="text-medium-6 text-text-primary mb-4 block shrink-0 px-16 uppercase md:mb-0"
      >
        {{ $ts('editorial.crossNavigation.viewMore') }}:
      </span>
      <div
        class="scrollbar-hide scroll flex items-center gap-2 overflow-x-auto pl-16"
      >
        <template v-for="(category, index) in categories" :key="category.label">
          <UILink
            v-bind="category"
            anatomy="link"
            :link-underline="false"
            class="text-light-6 h-auto shrink-0 p-0 last:mr-16"
          />
          <span v-if="index < categories.length - 1" class="text-text-primary">
            •
          </span>
        </template>
      </div>
    </div>
  </div>
</template>
